module.exports = __webpack_public_path__ + "img/data-table.4f84f112.jpg";